
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.light-blue, .mint-to-be{
  display:flex;
  flex-direction:column;
  align-items:center;
  padding:1rem;
  text-align:center;
}

.light-blue{
  background-color:var(--bh-brand-primary-lightest);
}

.mint-to-be{
  background-color:var(--eh-brand-secondary-100);
}

.section{
  max-width:16.37rem;
}

.section *{
    text-wrap:balance;
  }

.info-text{
  margin-top:0.5rem;
  font-size:0.9rem;
  color:var(--eh-brand-primary);
}

.link{
  margin-top:0.75rem;
  display:block;
}

.link:hover{
  text-decoration-line:underline;
}
`;